(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ascenting-header"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ascenting-navigation')){
  customElements.define('ascenting-navigation',class extends HTMLElement{
    connectedCallback(){
      if(this.controller)return;
      this.controller=new AbortController();
      const options={signal:this.controller.signal};
      const searchButton=this.querySelector('[data-asc-search]');
      const searchBox=this.querySelector('.asc-site-search');
      const details=[...this.querySelectorAll('details')];
      const closeMenus=()=>details.forEach(item=>item.open=false);
      searchButton.addEventListener('click',()=>{
        const open=searchBox.hidden;closeMenus();searchBox.hidden=!open;
        searchButton.setAttribute('aria-expanded',String(open));
        if(open)searchBox.querySelector('input[type=search]').focus();
      },options);
      details.forEach(item=>item.addEventListener('toggle',()=>{
        if(item.open){details.forEach(other=>{if(other!==item)other.open=false;});searchBox.hidden=true;searchButton.setAttribute('aria-expanded','false');}
      },options));
      this.addEventListener('click',event=>{if(event.target.closest('a'))closeMenus();},options);
      this.addEventListener('keydown',event=>{
        if(event.key!=='Escape')return;
        const open=details.find(item=>item.open);
        if(open){open.open=false;open.querySelector('summary').focus();}
        if(!searchBox.hidden){searchBox.hidden=true;searchButton.setAttribute('aria-expanded','false');searchButton.focus();}
      },options);
      document.addEventListener('click',event=>{if(!this.contains(event.target))closeMenus();},options);
      if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'){
        this.unsubscribe=subscribe(PUB_SUB_EVENTS.cartUpdate,async event=>{
          let count=event.cartData?.item_count;
          if(typeof count!=='number'){
            try{const response=await fetch(window.routes.cart_url+'.js');if(!response.ok)return;count=(await response.json()).item_count;}catch{return;}
          }
          if(typeof count==='number')this.querySelector('[data-asc-cart-count]').textContent=String(count);
        });
      }
    }
    disconnectedCallback(){this.controller?.abort();this.controller=null;this.unsubscribe?.();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ascenting-homepage"] && !Shopify.designMode) return;
  try {
    
(function(){
function init(){
 const root=document.getElementById('asc-home');if(!root||root.dataset.initialized)return;root.dataset.initialized='true';
 function setFamily(key){root.querySelectorAll('[data-scent]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.scent===key)));root.querySelectorAll('[data-scent-panel]').forEach(p=>p.hidden=p.dataset.scentPanel!==key);}
 root.querySelectorAll('[data-scent]').forEach(b=>b.addEventListener('click',()=>setFamily(b.dataset.scent)));
 root.addEventListener('shopify:block:select',e=>{const panel=e.target.closest('[data-scent-panel]');if(panel)setFamily(panel.dataset.scentPanel);});
}
init();document.addEventListener('shopify:section:load',init);
})();
if (!customElements.get('asc-review-carousel')) {
  customElements.define('asc-review-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.track = this.querySelector('.asc-review-track');
      this.dots = this.querySelector('.asc-review-dots');
      this.cards = Array.from(this.track.querySelectorAll('blockquote'));
      this.current = 0;
      this.onResize = () => this.layout();
      this.onScroll = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      };
      this.onKey = event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let target = this.current + (event.key === 'ArrowRight' ? 1 : -1);
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = this.pages - 1;
        this.go(target);
      };
      this.track.addEventListener('scroll', this.onScroll, {passive:true});
      this.track.addEventListener('keydown', this.onKey);
      window.addEventListener('resize', this.onResize);
      this.layout();
    }
    disconnectedCallback() {
      this.track.removeEventListener('scroll', this.onScroll);
      this.track.removeEventListener('keydown', this.onKey);
      window.removeEventListener('resize', this.onResize);
      cancelAnimationFrame(this.frame);
      this.initialized = false;
    }
    layout() {
      const previousCard = (this.current || 0) * (this.perPage || 1);
      this.perPage = matchMedia('(max-width:760px)').matches ? 1 : 2;
      this.pages = Math.ceil(this.cards.length / this.perPage);
      this.current = Math.min(Math.floor(previousCard / this.perPage), Math.max(0,this.pages - 1));
      this.dots.replaceChildren();
      for (let i = 0; i < this.pages; i++) {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-controls', this.track.id);
        button.setAttribute('aria-label', this.dataset.showLabel.replace('[first]', i * this.perPage + 1).replace('[last]', Math.min((i + 1) * this.perPage, this.cards.length)));
        button.addEventListener('click', () => this.go(i));
        this.dots.append(button);
      }
      this.dots.hidden = this.pages < 2;
      this.go(this.current, 'instant');
    }
    go(page, behavior) {
      const target = Math.max(0, Math.min(page, this.pages - 1));
      const card = this.cards[target * this.perPage];
      if (!card) return;
      const left = card.getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft;
      this.track.scrollTo({left, behavior:behavior || (matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth')});
      this.current = target;
      this.setDots();
    }
    update() {
      if (!this.cards.length) return;
      let best = 0, distance = Infinity;
      for (let i = 0; i < this.pages; i++) {
        const delta = Math.abs(this.cards[i * this.perPage].getBoundingClientRect().left - this.track.getBoundingClientRect().left);
        if (delta < distance) { distance = delta; best = i; }
      }
      this.current = best;
      this.setDots();
    }
    setDots() {
      Array.from(this.dots.children).forEach((button,i) => button.setAttribute('aria-current', String(i === this.current)));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
